import styled from 'styled-components';

export const Flag = styled.img.attrs({ className: 'dsc-flag', loading: 'lazy', decoding: 'async' })`
  flex-shrink: 0;
  border-radius: ${({ $isRounded }) => ($isRounded ? '50%' : 'unset')};
`;
